// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/customer.scss
// module id = 67
// module chunks = 0